var parseIntFromHex = function parseIntFromHex(hexValue) {
  return parseInt("0x".concat(hexValue), 16);
};

var splitHex = function splitHex(triHexValue) {
  return triHexValue.match(/.{1,2}/g);
};

export var getHexToRgb = function getHexToRgb(triHexValue) {
  return splitHex(triHexValue.replace('#', '')).map(parseIntFromHex).join(', ');
};